import { convertToDecimalWithPrecision } from "./convertToDecimalWithPrecision";
import { truncateDoubleTo } from "./truncateDoubleTo";

export function calculateBetBuilderOdd(bets) {
	let odd = convertToDecimalWithPrecision(1, 19, 6);
	for(let kb in bets){
		const bet = bets[kb];
		const betOdd = bet.odd;
		//const betOdd = (kb == 0? 139 : 162)
		//bet.odd = betOdd;
		odd = odd * convertToDecimalWithPrecision(betOdd, 19, 6)/100;
		odd = convertToDecimalWithPrecision(odd, 19, 6);		
	}
	odd = truncateDoubleTo(odd, 2);
	odd = parseInt((odd + "").replace(".", ""));
	return odd;	
}
